import { useState } from "react";
import { heroData } from "@/mocks/home";

export default function Hero() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(heroData.backupHost);
    } catch {
      /* clipboard unavailable — still give local feedback */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2400);
  };

  return (
    <header className="relative w-full overflow-hidden bg-accent-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20background%2C%20warm%20cream%20paper%20texture%20with%20bold%20vermilion%20geometric%20shapes%20and%20deep%20olive%20blocks%2C%20abstract%20risograph%20print%20style%2C%20soft%20film%20grain%2C%20dramatic%20side%20lighting%2C%20premium%20print%20aesthetic%2C%20high%20detail%2C%20harmonious%20warm%20color%20composition&width=1600&height=900&seq=hladdr-hero-01&orientation=landscape"
          alt="黑料地址镜像站与备用入口的杂志封面风格视觉"
          title="黑料地址 镜像站 备用入口 防封备用"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-accent-950/75 via-accent-950/60 to-accent-950/85"></div>
      </div>

      <div className="relative z-10 mx-auto w-full px-4 pb-20 pt-16 md:px-8 md:pb-28 md:pt-28">
        <div className="max-w-3xl">
          <p className="animate-fade-up font-label text-xs tracking-[0.32em] text-primary-300 md:text-sm">
            {heroData.eyebrow}
          </p>

          <h1 className="mt-5 animate-fade-up font-heading text-5xl font-black leading-[1.05] text-background-50 md:mt-6 md:text-7xl lg:text-8xl">
            {heroData.title}
            <span className="mt-3 block font-heading text-xl font-semibold text-background-300 md:mt-4 md:text-3xl">
              {heroData.titleAccent}
            </span>
          </h1>

          <p className="mt-7 max-w-2xl animate-fade-up text-sm leading-relaxed text-background-200 md:mt-8 md:text-base">
            {heroData.lede}
          </p>

          <div className="mt-9 flex w-full flex-col gap-3 sm:flex-row sm:items-center md:mt-10">
            <a
              href="#mirrors"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 font-label text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              <i className="ri-login-box-line text-base"></i>
              {heroData.primaryCta}
            </a>
            <button
              type="button"
              onClick={handleCopy}
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-transparent px-7 py-3.5 font-label text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-background-50/10"
            >
              <i className={copied ? "ri-check-line text-base" : "ri-file-copy-line text-base"}></i>
              {copied ? "已复制备用入口" : heroData.secondaryCta}
            </button>
          </div>

          <p
            className={`mt-3 font-label text-xs transition-opacity duration-300 md:text-sm ${
              copied ? "text-primary-300 opacity-100" : "text-background-300 opacity-0"
            }`}
          >
            备用入口 {heroData.backupHost} 已复制到剪贴板，建议同时收藏本页。
          </p>

          <dl className="mt-12 grid max-w-xl grid-cols-3 gap-4 border-t border-background-50/15 pt-7 md:mt-16 md:gap-8">
            {heroData.stats.map((item) => (
              <div key={item.label}>
                <dt className="font-label text-xs text-background-300 md:text-sm">{item.label}</dt>
                <dd className="mt-1.5 font-heading text-xl font-bold text-background-50 md:text-2xl">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </header>
  );
}